import { render, staticRenderFns } from "./footderbox.vue?vue&type=template&id=09e9ec23&scoped=true&"
import script from "./footderbox.vue?vue&type=script&lang=js&"
export * from "./footderbox.vue?vue&type=script&lang=js&"
import style0 from "./footderbox.vue?vue&type=style&index=0&id=09e9ec23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e9ec23",
  null
  
)

export default component.exports